import React from "react";
import PlaidLink from "./PlaidLink";

export default function UserInformation() {
  return (
    <div className="flex items-center justify-center mt-4">
      <PlaidLink />
    </div>
  );
}
